<template>
  <el-dialog :visible.sync="visible" width="min(860px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="readonly && form.id" class="doc-dialog-actions">
          <el-button-group>
            <workflow-doc-buttons biz-type="advanceReceipt" :biz-id="form.id" perm="finance:advanceReceipt" :approve-status="String(form.approveStatus || '0')" @approve="approve(form, true)" @unapprove="approve(form, false)" />
            <el-button v-if="canAllocate" type="primary" size="small" @click="openAllocation">继续核销</el-button>
            <el-button v-if="laterAllocations.length" size="small" @click="allocationHistory = true">核销记录</el-button>
            <el-button v-if="isAuth('finance:advanceReceipt:update') || isAuth('finance:advanceReceipt:save')" type="primary" size="small" :disabled="!canEditDoc" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('finance:advanceReceipt:delete') || isAuth('finance:advanceReceipt:save')" type="danger" size="small" :disabled="!canEditDoc" @click="deleteFromView">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : formRules" :validate-on-rule-change="false" :disabled="readonly" label-width="110px">
      <el-form-item label="预收款单号" prop="code"><el-input v-model="form.code" :readonly="codeReadonly || !!form.id" :placeholder="codeReadonly ? '保存时自动生成' : ''" /></el-form-item>
      <el-form-item label="日期" prop="bizDate">
        <el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
      </el-form-item>
      <el-form-item label="客户" prop="customerId">
        <el-input :value="form.partnerName" readonly placeholder="请选择客户">
          <el-button v-if="!readonly" slot="append" @click="picker = true">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="金额" prop="amount">
        <el-input-number v-model="form.amount" :min="0" :precision="2" style="width:100%" />
      </el-form-item>
      <el-form-item v-if="readonly && String(form.approveStatus) === '2'" label="未核销金额">
        <el-input :value="money(form.unallocatedAmount)" disabled />
      </el-form-item>
      <el-form-item label="核销应收">
        <el-button v-if="!readonly" size="small" type="primary" :disabled="!form.customerId" @click="openWriteOff">选择核销应收（可选）</el-button>
      </el-form-item>
      <el-table :data="form.lines" border size="small" :header-cell-style="headStyle">
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column prop="billCode" label="应收单号" min-width="140" />
        <el-table-column prop="applyDate" label="后续核销日期" width="130" />
        <el-table-column label="核销金额" width="150">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.writeOffMoney" :min="0" :max="readonly ? Math.max(Number(scope.row.writeOffMoney || 0), Number(scope.row.remainAmount || 0)) : Number(scope.row.remainAmount || 0)" :precision="2" :disabled="readonly" size="small" style="width:100%" />
          </template>
        </el-table-column>
        <el-table-column v-if="!readonly" label="操作" width="60" align="center">
          <template slot-scope="scope"><el-button type="text" size="small" @click="form.lines.splice(scope.$index, 1)">删</el-button></template>
        </el-table-column>
      </el-table>
      <el-form-item label="备注" style="margin-top:12px"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
    <CustomerSelector :visible.sync="picker" @select="onPick" />
    <el-dialog title="选择核销应收" :visible.sync="writeoff" width="min(720px, calc(100vw - 24px))" append-to-body :close-on-click-modal="false">
      <el-table :data="candidates" border height="320" @selection-change="rows => picked = rows">
        <el-table-column type="selection" width="46" />
        <el-table-column prop="billCode" label="应收单号" width="160" />
        <el-table-column prop="materialName" label="物料" min-width="140" />
        <el-table-column prop="remainAmount" label="可核销" width="110" align="right" />
      </el-table>
      <span slot="footer">
        <el-button @click="writeoff = false">取消</el-button>
        <el-button type="primary" @click="confirmWriteOff">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="继续核销预收款" :visible.sync="allocationDialog" width="min(760px, calc(100vw - 24px))" append-to-body :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="核销日期"><el-date-picker v-model="allocationDate" type="date" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item>
      </el-form>
      <div class="allocation-available">预收未核销：{{ money(form.unallocatedAmount) }}</div>
      <el-table class="allocation-table" :data="allocationCandidates" border height="300" @selection-change="rows => selectedAllocations = rows">
        <el-table-column type="selection" width="46" />
        <el-table-column label="类型" width="85"><template slot-scope="scope">{{ scope.row.writeOffType === 'invoice' ? '发票' : '应收明细' }}</template></el-table-column>
        <el-table-column label="单号 / 物料" min-width="145" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.billCode }}{{ scope.row.materialName ? ' / ' + scope.row.materialName : '' }}</template>
        </el-table-column>
        <el-table-column prop="remainAmount" label="可核销" width="80" align="right" />
        <el-table-column label="本次核销" width="120">
          <template slot-scope="scope"><el-input-number v-model="scope.row.writeOffMoney" :min="0" :max="Number(scope.row.remainAmount || 0)" :precision="2" size="small" style="width:100%" /></template>
        </el-table-column>
      </el-table>
      <div class="allocation-mobile">
        <div v-for="row in allocationCandidates" :key="row.billLineId || row.billId" class="allocation-card">
          <div class="allocation-card-head">
            <el-checkbox :value="isAllocationSelected(row)" @change="checked => toggleAllocation(row, checked)" />
            <span class="allocation-card-type">{{ row.writeOffType === 'invoice' ? '发票' : '应收明细' }}</span>
            <strong>{{ row.billCode }}</strong>
          </div>
          <div v-if="row.materialName" class="allocation-card-material">{{ row.materialName }}</div>
          <div class="allocation-card-amount">
            <span>可核销 {{ money(row.remainAmount) }}</span>
            <el-input-number v-model="row.writeOffMoney" :min="0" :max="Number(row.remainAmount || 0)" :precision="2" size="small" />
          </div>
        </div>
      </div>
      <span slot="footer"><el-button @click="allocationDialog = false">取消</el-button><el-button type="primary" :loading="allocationSaving" @click="saveAllocation">确认核销</el-button></span>
    </el-dialog>
    <el-dialog title="后续核销记录" :visible.sync="allocationHistory" width="min(680px, calc(100vw - 24px))" append-to-body>
      <el-table :data="laterAllocations" border size="small">
        <el-table-column prop="applyDate" label="核销日期" width="115" />
        <el-table-column prop="billCode" label="来源单号" min-width="130" show-overflow-tooltip />
        <el-table-column label="核销金额" width="110" align="right"><template slot-scope="scope">{{ money(scope.row.writeOffMoney) }}</template></el-table-column>
        <el-table-column v-if="isAuth('finance:advanceReceipt:update') || isAuth('finance:advanceReceipt:save')" label="操作" width="90" align="center"><template slot-scope="scope"><el-button type="text" size="small" @click="reverseAllocation(scope.row)">撤销核销</el-button></template></el-table-column>
      </el-table>
    </el-dialog>
  </el-dialog>
</template>

<script>
import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'
import CustomerSelector from '../../components/CustomerSelector.vue'
import request from '../../api/request'
import auth from './financeAuth'

export default {
  name: 'AdvanceReceiptAddOrUpdate',
  mixins: [auth],
  components: { WorkflowDocButtons, CustomerSelector },
  data() {
    return {
      visible: false,
      readonly: false,
      codeReadonly: false,
      picker: false,
      writeoff: false,
      candidates: [],
      picked: [],
      allocationDialog: false,
      allocationHistory: false,
      allocationSaving: false,
      allocationDate: '',
      allocationCandidates: [],
      selectedAllocations: [],
      form: this.blank(),
      rules: {
        code: [{ required: true, message: '预收款单号不能为空', trigger: 'blur' }],
        bizDate: [{ required: true, message: '日期不能为空', trigger: 'change' }],
        customerId: [{ required: true, message: '客户不能为空', trigger: 'change' }],
        amount: [{ required: true, message: '金额不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    formRules() {
      return this.codeReadonly ? { bizDate: this.rules.bizDate, customerId: this.rules.customerId, amount: this.rules.amount } : this.rules
    },
    dialogTitle() {
      if (this.readonly) return '查看预收款单'
      return this.form.id ? '修改预收款单' : '新增预收款'
    },
    canAllocate() {
      return this.readonly && String(this.form.approveStatus) === '2' && Number(this.form.unallocatedAmount || 0) > 0 &&
        (this.isAuth('finance:advanceReceipt:update') || this.isAuth('finance:advanceReceipt:save'))
    },
    laterAllocations() {
      return (this.form.lines || []).filter(line => String(line.allocationType || '0') === '1')
    }
  },
  methods: {
    blank() {
      return { kind: 'advanceReceipt', code: '', bizDate: this.today(), customerId: '', partnerName: '', amount: 0, remark: '', lines: [] }
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.codeReadonly = false
      this.picker = false
      this.writeoff = false
      this.allocationDialog = false
      this.allocationHistory = false
      if (!id) {
        this.form = this.blank()
        this.resolveCode()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/finance/doc/info', { params: { kind: 'advanceReceipt', id } }).then(res => {
        const row = res.data || {}
        this.form = Object.assign({ kind: 'advanceReceipt', lines: [] }, row)
        if (!Array.isArray(this.form.lines)) this.form.lines = []
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() {
      this.form = this.blank()
      this.readonly = false
      this.codeReadonly = false
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'advanceReceipt' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.form.code = data.previewCode
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate('code'))
      }).catch(() => {})
    },
    editFromView() {
      if (!this.assertCanEditDoc('edit')) return
      this.readonly = false
    },
    deleteFromView() {
      if (String(this.form.approveStatus) === '2') {
        this.$message.warning('已审核的单据不可删除，请先弃审')
        return
      }
      this.$confirm('确定删除该预收款单?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/doc/delete', { kind: 'advanceReceipt', id: this.form.id }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    onPick(row) {
      if (this.form.customerId && this.form.customerId !== row.customerId) this.form.lines = []
      this.form.customerId = row.customerId
      this.form.partnerName = row.customerName
    },
    openWriteOff() {
      request.get('/finance/cash/pendingAdvanceWriteOff', { params: { kind: 'advanceReceipt', partnerId: this.form.customerId, excludeId: this.form.id || '' } }).then(res => {
        this.candidates = res.data || []
        this.picked = []
        this.writeoff = true
      }).catch(() => {})
    },
    confirmWriteOff() {
      const exists = new Set((this.form.lines || []).map(line => line.receivableLineId || line.billLineId))
      this.picked.forEach(row => {
        if (exists.has(row.billLineId)) return
        this.form.lines.push({ receivableId: row.billId, receivableLineId: row.billLineId, billCode: row.billCode, remainAmount: Number(row.remainAmount || 0), writeOffMoney: Number(row.remainAmount || 0) })
      })
      this.writeoff = false
    },
    openAllocation() {
      this.allocationDate = this.today()
      request.get('/finance/cash/pendingAdvanceWriteOff', { params: { kind: 'advanceReceipt', partnerId: this.form.customerId, includeInvoice: true } }).then(res => {
        this.allocationCandidates = (res.data || []).map(row => Object.assign({}, row, { writeOffMoney: Number(row.remainAmount || 0) }))
        if (!this.allocationCandidates.length) this.$message.info('当前客户没有可核销的应收明细或发票')
        this.selectedAllocations = []
        this.allocationDialog = true
      }).catch(() => {})
    },
    isAllocationSelected(row) {
      return this.selectedAllocations.some(item => item === row)
    },
    toggleAllocation(row, checked) {
      this.selectedAllocations = checked
        ? [...this.selectedAllocations, row]
        : this.selectedAllocations.filter(item => item !== row)
    },
    saveAllocation() {
      const lines = this.selectedAllocations.map(row => row.writeOffType === 'invoice'
        ? { salesInvoiceId: row.billId, writeOffMoney: Number(row.writeOffMoney || 0) }
        : { receivableId: row.billId, receivableLineId: row.billLineId, writeOffMoney: Number(row.writeOffMoney || 0) })
      const sum = lines.reduce((value, row) => value + row.writeOffMoney, 0)
      if (!this.allocationDate || !lines.length || lines.some(row => row.writeOffMoney <= 0) || sum > Number(this.form.unallocatedAmount || 0) + 0.001) {
        this.$message.warning('请选择明细并填写不超过预收余额的核销金额及日期')
        return
      }
      this.allocationSaving = true
      request.post('/finance/doc/advanceAllocate', { kind: 'advanceReceipt', id: this.form.id, applyDate: this.allocationDate, lines }).then(() => {
        this.$message.success('核销成功')
        this.allocationDialog = false
        this.init(this.form.id, true)
        this.$emit('refreshDataList')
      }).catch(() => {}).finally(() => { this.allocationSaving = false })
    },
    reverseAllocation(row) {
      this.$confirm('确定撤销该笔后续核销及其凭证?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/doc/advanceAllocationReverse', { kind: 'advanceReceipt', id: this.form.id, allocationId: row.allocationId }).then(() => {
          this.$message.success('核销已撤销')
          this.allocationHistory = false
          this.init(this.form.id, true)
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/finance/doc/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    approve(row, pass) {
      const url = pass ? '/finance/doc/approve' : '/finance/doc/unapprove'
      this.$confirm(pass ? '确定审核?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {
        request.post(url, { kind: 'advanceReceipt', id: row.id }).then(() => {
          this.$message.success(pass ? '审核成功' : '弃审成功')
          if (row && this.form && ((row.id && this.form.id === row.id) || (row.voucherId && this.form.voucherId === row.voucherId))) {
            this.init(this.form.id, true)
          }
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
.allocation-available { margin-bottom: 10px; color: #606266; }
.allocation-mobile { display: none; }
@media (max-width: 600px) {
  .allocation-table { display: none; }
  .allocation-mobile { display: block; max-height: 320px; overflow-y: auto; }
  .allocation-card { padding: 12px; border: 1px solid #dcdfe6; border-radius: 6px; margin-bottom: 8px; }
  .allocation-card-head { display: flex; align-items: center; gap: 8px; min-width: 0; }
  .allocation-card-head strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .allocation-card-type { flex: none; color: #606266; font-size: 12px; }
  .allocation-card-material { color: #909399; font-size: 12px; margin-top: 6px; }
  .allocation-card-amount { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-top: 10px; }
  .allocation-card-amount .el-input-number { width: 132px; flex: none; }
}
</style>
